import { getNextPositionFromEdge, getNextPositionFromEdges } from './get-next-position.checks';

export const getNextPosition = (allCollisions, currentPosition) => {
  const currentAlignmentSegments = currentPosition.split('-');
  // If this is something like 'left-bottom' vs 'bottom-left', flip the variables
  const flipItFlipItGood = ['left', 'right'].indexOf(currentAlignmentSegments[0]) !== -1;
  const aggregateCollisions = allCollisions.reduce((acc, collisions) => ({ ...acc, ...collisions }), {});

  // Quick short circuit here, if we're colliding on at least 3 sides, just return the 4th side
  if (Object.keys(aggregateCollisions).length === 3) {
    return Object.keys(aggregateCollisions).reduce(
      (acc, key) => {
        acc.splice(acc.indexOf(key), 1);
        return acc;
      },
      ['bottom', 'left', 'right', 'top'],
    )[0];
  }

  let nextPosition;

  // If we're dealing with a single word direction (e.g. top/bottom/left/right)
  if (currentAlignmentSegments.length === 1) {
    // Is this a left/right item that might try left-bottom/right-top instead? Or a top/bottom item that might want top-right/left-bottom?
    // If so, we set this flipItFlipItGood bit here, because we process top/bottom collisions first, so when we get to the end of the line,
    // we want to flip the array such that we return (e.g.) left-top or right-top vs top-left or top-right
    nextPosition = getNextPositionFromEdge(currentPosition, aggregateCollisions, flipItFlipItGood);

    if (flipItFlipItGood) {
      nextPosition.reverse();
    }
  } else {
    nextPosition = getNextPositionFromEdges(currentPosition, aggregateCollisions, flipItFlipItGood);

    // If this is something like 'left-bottom' vs 'bottom-left', flip the array so the nextPosition outputs properly
    if (flipItFlipItGood) {
      nextPosition.reverse();
    }
  }

  return nextPosition.join('-');
};
